/**
@license
Copyright (c) 2019 Behavio Labs s.r.o. All rights reserved.
*/

import { LitElement } from 'lit-element';

export class BaseElement extends LitElement {
  static get properties() {
    return {
      // The store contains app state.
      store: { type: Object },
    };
  }

  // Fire a custom event.
  // By default, a bubbling custom event fired inside shadow DOM will stop bubbling when it reaches the shadow root.
  // To make a custom event pass through shadow DOM boundaries, you must set bubbles arg to true.
  // https://lit-element.polymer-project.org/guide/events#custom-events
  _dispatch(eventName, detail, bubbles = false) {
    const event = new CustomEvent(eventName, { detail, bubbles, composed: bubbles });
    this.dispatchEvent(event);
  }

  // Get element of Shadow Root by ID.
  _get(elementID) {
    return this.shadowRoot.getElementById(elementID);
  }

  // Go to page path.
  _go(path) {
    this._dispatch('go-page', path, true);
  }

  // Propagate property changes for object subproperties.
  // Mutations (changes to object subproperties and array items) are not observable.
  // Instead, rewrite the whole object.
  // https://lit-element.polymer-project.org/guide/lifecycle#examples
  _update(property, object) {
    // Rewrite whole object, triggering an update.
    this[property] = Object.assign({}, this[property], object);
  }

  // Update store of app state.
  _updateStore(object) {
    this._dispatch('update-store', object, true);
  }
}
